<div class="welcome-container w-100 h-100 background-image" >
    <div class="spacer h-100 float-start"></div>
    <div class="logo-container">
           <img src="assets/images/icons/monex_login_icon.svg" alt="monex-icon"><br>
    </div>
    <div class="line-container">
        <hr class="vr-line">
    </div>
    <div class="welcome-content">
        <div class="wlcm-content">
            <span class="wlcm-1">{{"Bienvenido" | translate}}</span><br>
            <span class="wlcm-2">{{"NBD" | translate}}</span><br><br>
            <span class="wlcm-3">{{"Nos encanta tenerte aquí" | translate}}</span><br><br>
            <div class="wlcm-btn">
                <button type="button" class="btn btn-banca-digital" (click)="showLogin()">
                    <span>{{"Continuar" | translate}}</span>
                </button>
            </div>     
        </div>
    </div>
</div>
